module.exports = __webpack_public_path__ + "order/img/membership-core.0233f47a.svg";